import { ReactNode } from 'react';

import styles from './GlobalAccessRestrictedDescription.module.css';

interface GlobalAccessRestrictedDescriptionProps {
  children: ReactNode;
}

function GlobalAccessRestrictedDescription(props: GlobalAccessRestrictedDescriptionProps) {
  const { children } = props;

  return <div className={styles.restrictedDescription}>{children}</div>;
}

export default GlobalAccessRestrictedDescription;
